import React from "react";
import { useTranslation } from "react-i18next";
import { Box, BoxVariant } from "../Box";
import { ContentWithTitle } from "../ContentWithTitle";
import { RowWithIconContainer } from "../RowWithIconContainer";
import { Icons } from "../../utils";
import { TextNature } from "../../types";

export type IsPaidBannerProps = {
  paymentStatus?: boolean;
};

export const IsPaidBanner: React.FC<IsPaidBannerProps> = ({ paymentStatus }) => {
  const { t } = useTranslation();

  return (
    <ContentWithTitle title={t("fees")}>
      <Box variant={paymentStatus ? undefined : BoxVariant.warning}>
        <RowWithIconContainer
          iconName={paymentStatus ? Icons.successCircle : Icons.warningCircle}
          mainText={paymentStatus ? t("feesPaid") : t("feesNotPaid")}
          secondaryText={paymentStatus ? t("feesPaidInfo") : t("feesNotPaidInfo")}
          secondaryTextNature={paymentStatus ? undefined : TextNature.light}
        />
      </Box>
    </ContentWithTitle>
  );
};
